module.exports = __webpack_public_path__ + "static/media/resetProfile.d6a5022e.webp";